<template>
  <div class="sidebarArray" v-if="container && element">
    <div class="property-input" :class="{selected: isSelected}" @click="setSelectedElement(element?.previewId)">
      <div class="property-header">
        <div class="property-header-left">
          <label class="property-label">
            {{ property.text }}
          </label>
          <!-- Bouton visible-->
          <button class="short-button" title="Options" @click="updateProperty({element: element, property: {name: 'Show'}, value: !element.Show})">
            <svg xmlns="http://www.w3.org/2000/svg" class="short-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
              <line v-if="!element.Show" x1="1" y1="23" x2="23" y2="1" stroke-width="2"/>
            </svg>
          </button>
          <!-- Bouton options -->
          <button class="short-button" title="Options" @click="contextMenuElementSelect($event)">
            <svg xmlns="http://www.w3.org/2000/svg" class="short-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="1" />
              <circle cx="12" cy="5" r="1" />
              <circle cx="12" cy="19" r="1" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <DeleteConfirmPopup
      :show="showDeleteConfirm"
      :elementName="element?.Name ? element.Name : ''"
      @close="showDeleteConfirm = false"
      @confirm="confirmDelete"
    />
    <NameElementPopup :show="showNameEdit" :defaultName="element?.Name ? element.Name : ''" @close="showNameEdit = false" @named="changeName"/>
    <context-menu v-model:show="contextMenuShow" :options="contextMenuComponent">
      <context-menu-item v-if="element.CanChangeName" @click="showNameEdit = true">
        <template #icon>
          <textIcon/>
        </template>
        <template #label>
          Modifier le nom
        </template>
      </context-menu-item>
      <context-menu-item v-if="element.CanBeRemove" @click="showDeleteConfirm = true; contextMenuShow = false;">
        <template #icon>
          <deleteIcon/>
        </template>
        <template #label>
          Supprimer l'élément
        </template>
      </context-menu-item>
    </context-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as namespaceStore from "../../../vuexStore/namespaceStore.js"
import * as actions from "../../../vuexStore/actions.js"
import DeleteConfirmPopup from '../../PopupComponents/DeleteConfirmPopup.vue'
import NameElementPopup from '../../PopupComponents/NameElementPopup.vue'
import upperIcon from "../../IconComponents/upperIcon.vue"
import lowerIcon from "../../IconComponents/lowerIcon.vue"
import deleteIcon from "../../IconComponents/deleteIcon.vue"
import textIcon from "../../IconComponents/textIcon.vue"

export default {
  name: 'Class',
  props: {
    property: {
      type: [Object, null],
      required: true
    },
    element: {
      type: [Object, null],
      required: true
    },
    container: {
      type: [Object, null],
      required: true
    }
  },
  emits: [
  ],
  components: {
    DeleteConfirmPopup,
    NameElementPopup,
    upperIcon,
    lowerIcon,
    deleteIcon,
    textIcon
  },
  data() {
    return {
      showDeleteConfirm: false,
      showNameEdit: false,
      contextMenuShow: false,
      contextMenuComponent: {
        zIndex: 3,
        minWidth: 230,
        x: 0,
        y: 0
      },
    }
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      'currentElementIndex',
    ]),
    isSelected: function() {
        if (this.currentElementIndex && this.element) {
            return this.element.previewId == this.currentElementIndex;
        }
        return false;
    }
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
        'setSelectedElement': actions.SET_SELECTED_ELEMENT,
        'updateProperty': actions.UPDATE_PROPERTY,
        'actionRemoveElement': actions.REMOVE_PAGE_ELEMENT,
    }),
    changeName: function(text) {
      this.updateProperty({element: this.element, property: {name: "Name"}, value: text});
      this.showNameEdit = false;
    },
    contextMenuElementSelect: function(event) {
      this.contextMenuShow = true;
      this.contextMenuComponent.x = event.x;
      this.contextMenuComponent.y = event.y;
    },
    confirmDelete() {
      this.actionRemoveElement(this.element.previewId);
      this.showDeleteConfirm = false;
    },
  }
}
</script>

<style scoped>
.short-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
  transition: all 0.2s ease;
  padding: 0;
}

.short-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.short-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}

.short-icon {
  width: 1rem;
  height: 1rem;
}


.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
  cursor: pointer;
}

.property-input.selected {
    border: 1px solid #3b82f6;
}

.property-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0;
  gap: 10px;
}

.property-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.property-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #e5e7eb;
  flex: 1;
}
</style> 